import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFlightCategory } from 'src/models/flight-category.model';
import services from 'src/services/flight-category.service';

export const actionTypes = {
  FLIGHT_CATEGORY_FETCH: 'FLIGHT_CATEGORY_FETCH',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.FLIGHT_CATEGORY_FETCH,
    service: services.listGET,
  },
};

export type IFlightCategoryAsync = typeof asyncActions;

export interface IFlightCategoryState
  extends ICommonState<IFlightCategoryAsync> {
  data?: IFlightCategory;
  list: IFlightCategory[];
  total: number;
}

export const defaultState: IFlightCategoryState = {
  status: {},
  list: [],
  total: 0,
};

const FlightCategoryReducer = (
  state: IFlightCategoryState = defaultState,
  action: IReducerAction<IFlightCategoryAsync>
): IFlightCategoryState => {
  switch (action.type) {
    case actionTypes.FLIGHT_CATEGORY_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default FlightCategoryReducer;
